<div class="container">
  @if (evaluation) {
  <mat-card appearance="raised" class="card-evaluation">
    <mat-card-header class="card-header fx-direction-row fx-align-item-center"
      [class.card-header-examen]="evaluation.examen">
      <mat-card-title class="fx-direction-row fx-between-center fx-gap-10">
        <div class="card-header-badge" [class.badge-examen]="evaluation.examen">
          @if(evaluation.examen){
          <app-icon type="do" icon="groupe-commission" />
          }@else {
          <app-icon type="do" icon="evaluation" />
          }
          <span>N°{{ evaluation.numEvaluation }}</span>
        </div>
        <span>{{ evaluation.libelle.libelle }}</span>
        <div class="annee-scolaire-badge" matTooltip="Année scolaire">
          <app-icon type="do" icon="annee-scolaire" />
          <span>{{ evaluation.anneeScolaireName }}</span>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="fx-flex-1 card-content">
      <div class="info-eval">
        <div>
          <app-icon type="do" icon="date-range" />
          @if (evaluation.dateDebut === evaluation.dateFin) {
          {{evaluation.dateDebut | date:'shortDate'}}
          }@else{
          Du {{evaluation.dateDebut | date:'shortDate'}} au {{evaluation.dateFin |
          date:'shortDate'}}
          }
        </div>
        <div>
          <app-icon type="do" icon="departement" />
          {{ evaluation.departement }}
        </div>
        @if (evaluation.discipline) {
        <div><app-icon type="do" icon="discipline" />
          {{evaluation.discipline.libelle}}
        </div>
        }
        @if (evaluation.cours) {
        <div><app-icon type="do" icon="cours" />
          {{evaluation.cours.libelle}}
        </div>
        }
      </div>

      <div class="accordion-scroll-wrapper">
        <div class="inscriptions-list thin-scrollbar">
          @for(inscription of evaluationInscriptions();track $index;let idx = $index;){
          <div class="inscription-row">
            <mat-slide-toggle [checked]="inscription.selected()" (change)="inscription.selected.set($event.checked)"
              style="margin-inline: 10px;"
              [matTooltip]="evaluation.examen ? 'Inscription à l\'examen' : 'Inscription à l\'évaluation'"
              color="primary"></mat-slide-toggle>
            @if(evaluation.examen){
            <mat-icon [style.color]="inscription.reussiteExamen ? '#6EBF6D' : '#DA5255'"
              [matTooltip]="inscription.reussiteExamen ? 'Réussite à l\'examen' : 'Échec à l\'examen'"
              style="min-width: 24px;">{{inscription.reussiteExamen ? 'check_circle' : 'cancel'}}</mat-icon>
            }
            <span style="margin-left: 5px; flex: 1; max-width: 200px;">{{inscription.nomReferent}}</span>
            <div class="inscription-description">
              @if(inscription.noteGlobale){
              <span class="note" matTooltip="Note globale">{{inscription.noteGlobale}}</span>
              }
              <span class="appreciation-preview">{{inscription.appreciation}}</span>
              @if(config?.showOtherTeachersEvaluations){
              <button mat-icon-button [matTooltip]="'Autres évaluations de ' + inscription.nomReferent"
                (click)="openDialogEvaluationsByInscription(inscriptionInfoEvaluation, inscription)" color="accent">
                <mat-icon>list_alt</mat-icon>
              </button>
              }
              <button mat-icon-button matTooltip="Éditer" color="primary"
                (click)="openDialogEditInscription(inscriptionEditDialog, inscription, idx)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
          }@empty {
          <div class="no-inscription-container">
            {{'enseignant_evaluation.no_inscriptions' | trans}}
          </div>
          }
        </div>
      </div>

    </mat-card-content>
    <mat-card-actions align="end">
      <button color="primary" mat-raised-button aria-label="Enregistrer" (click)="saveEvaluation(evaluation)"
        [disabled]="!evaluationInscriptions().length || saving">

        <mat-icon [hidden]="saving">save</mat-icon>
        <div class="fx-direction-row fx-align-item-center fx-gap-5">
          @if (saving) {
          <mat-progress-spinner mode="indeterminate" strokeWidth="2" diameter="18"
            color="accent"></mat-progress-spinner>
          }
          <span>Enregistrer</span>
        </div>

      </button>
    </mat-card-actions>
  </mat-card>

  }@else {
  <app-loader message="Chargement des données..." class="margin" />
  }

</div>

<ng-template #critereField let-critere="critere" let-inscription="inscription" let-idx="idx">
  @let status = getCritereStatus(critere, inscription);
  @switch (critere.type) {
  @case ("numerique") {
  <div class="form-field-critere">
    @if(status !== null){<span class="critere-status" [class.status-reussi]="status"
      [class.status-echec]="!status"></span>}
    <label class="critere-label fx-direction-row fx-start-center">
      @if(critere.obligatoire){
      <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire">error</mat-icon>
      }
      <span>
        {{critere.critere}} (<span style="font-style: italic;">coefficient :
          {{critere.coefficient}}</span>)
      </span>
    </label>
    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
      <input matInput [(ngModel)]="inscription.criteresData[critere.id]" [disabled]="!inscription.selected()"
        (ngModelChange)="recalculerNoteGlobale(idx);actualiserReussite(idx)" type="number"
        name="critere_{{critere.id}}">
    </mat-form-field>
  </div>
  }
  @case ("checkbox") {
  <div class="form-field-critere fx-direction-row fx-align-item-center">
    @if(status !== null){<span class="critere-status" [class.status-reussi]="status"
      [class.status-echec]="!status"></span>}
    @if(critere.obligatoire){
    <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire" style="margin-right: 0;">error</mat-icon>
    }
    <mat-checkbox style="width: 100%;" [(ngModel)]="inscription.criteresData[critere.id]" name="critere_{{critere.id}}"
      (ngModelChange)="actualiserReussite(idx)" [disabled]="!inscription.selected()">{{critere.critere}}</mat-checkbox>
  </div>
  }
  @case ("liste") {
  <div class="form-field-critere">
    @if(status !== null){<span class="critere-status" [class.status-reussi]="status"
      [class.status-echec]="!status"></span>}
    <label class="critere-label fx-direction-row fx-start-center">
      @if(critere.obligatoire){
      <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire">error</mat-icon>
      }
      <span>{{critere.critere}}</span>
    </label>
    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
      <mat-select [(ngModel)]="inscription.criteresData[critere.id]" (ngModelChange)="actualiserReussite(idx)"
        [disabled]="!inscription.selected()" name="critere_{{critere.id}}" panelClass="critere-select-panel">
        @if(isMobile){
        <mat-optgroup [label]="critere.critere">
          <mat-option>--</mat-option>
          @for (valeur of critere.valeurs; track valeur) {
          <mat-option [value]="valeur.id">{{valeur.libelle}}</mat-option>
          }
        </mat-optgroup>
        }@else {
        <mat-option>--</mat-option>
        @for (valeur of critere.valeurs; track valeur) {
        <mat-option [value]="valeur.id">{{valeur.libelle}}</mat-option>
        }
        }
      </mat-select>
    </mat-form-field>
  </div>
  }
  @case ("texte") {
  <div class="form-field-critere" style="width: 100%;">
    @if(status !== null){<span class="critere-status" [class.status-reussi]="status"
      [class.status-echec]="!status"></span>}
    <label class="critere-label fx-direction-row fx-start-center">
      @if(critere.obligatoire){
      <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire">error</mat-icon>
      }
      <span>{{critere.critere}}</span>
    </label>
    <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
      <textarea matInput [(ngModel)]="inscription.criteresData[critere.id]" [disabled]="!inscription.selected()"
        (ngModelChange)="actualiserReussite(idx)" name="critere_{{critere.id}}" cdkTextareaAutosize
        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3"></textarea>
    </mat-form-field>
  </div>
  }
  }
</ng-template>

<ng-template #critereInfoCompact let-critere="critere" let-evalInscription="evalInscription">
  @let value = evalInscription.criteresData[critere.id];
  @let status = getCritereStatus(critere, evalInscription);
  <div class="critere-compact-row">
    @if(status !== null){<span class="critere-status" [class.status-reussi]="status"
      [class.status-echec]="!status"></span>}
    <span class="evaluation-label fx-direction-row fx-start-center">
      @if(critere.obligatoire){
      <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire">error</mat-icon>
      }
      {{ critere.critere }}
    </span>
    <span class="critere-compact-value">
      @switch (critere.type) {
      @case ('numerique') {
      <span class="note-compact">{{ value ?? 0 }}</span>
      }
      @case ('checkbox') {
      <mat-icon [style.color]="value ? '#6EBF6D' : '#DA5255'" style="font-size: 24px; height: 24px; width: 24px;">
        {{ value ? 'check_circle' : 'cancel' }}
      </mat-icon>
      }
      @case ('liste') {
      @for (v of critere.valeurs; track v) {
      @if (v.id === value) { {{ v.libelle }} }
      }
      }
      @case ('texte') {
      <span class="texte-compact">{{ value }}</span>
      }
      }
    </span>
  </div>
</ng-template>

<ng-template #inscriptionEditDialog let-data>
  <app-dialog-header [title]="data.inscription.nomReferent" />
  <mat-dialog-content class="content-dialog">
    <form class="form-evaluation">
      @if(evaluation.examen || evaluation.criteresNotation?.length){
      <div class="critere-col">
        @if(evaluation.examen){
        <div class="reussite-header">
          <mat-button-toggle-group [(ngModel)]="data.inscription.reussiteExamen" name="reussiteExamen"
            (ngModelChange)="actualiserReussite(data.idx,true)" [disabled]="!data.inscription.selected()"
            class="reussite-toggle" [class.has-criteres]="evaluation.criteresNotation?.length"
            hideSingleSelectionIndicator style="width: 100%;">
            <mat-button-toggle [value]="true" class="toggle-reussite">
              <mat-icon>check_circle</mat-icon>
              Réussite
            </mat-button-toggle>
            <mat-button-toggle [value]="false" class="toggle-echec">
              <mat-icon>cancel</mat-icon>
              Échec
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        }
        @if (evaluation.criteresNotation && data.inscription.criteresData){
        <div class="critere-zone" [class.no-examen]="!evaluation.examen">
          @if (config?.sortedByCode) {
          @for (group of criteresByCode; track group.code) {
          <div class="critere-group">
            @if (group.code) {
            <div class="critere-group-header">{{group.code}}</div>
            }
            <div class="fx-direction-row fx-wrap fx-gap-2">
              @for (critere of group.criteres; track $index) {
              <ng-container
                *ngTemplateOutlet="critereField; context: { critere: critere, inscription: data.inscription, idx: data.idx }"></ng-container>
              }
            </div>
          </div>
          }
          } @else {
          <div class="fx-direction-row fx-wrap fx-gap-2">
            @for (critere of evaluation.criteresNotation; track $index) {
            <ng-container
              *ngTemplateOutlet="critereField; context: { critere: critere, inscription: data.inscription, idx: data.idx }"></ng-container>
            }
          </div>
          }
        </div>
        }
      </div>
      }
      <div class="appreciation-zone fx-direction-col fx-gap-2"
        [class.full-width]="!evaluation.criteresNotation?.length">
        <div class="form-field-critere" style="width: 100%;">
          <label class="critere-label">Appréciation</label>
          <mat-form-field style="width: 100%;" subscriptSizing="dynamic">
            <textarea matInput [(ngModel)]="data.inscription.appreciation" name="appréciation"
              [disabled]="!data.inscription.selected()" cdkTextareaAutosize cdkAutosizeMinRows="5"
              cdkAutosizeMaxRows="8"></textarea>
          </mat-form-field>
        </div>
        @if(evaluation.criteresNotation?.length){
        @let stats = getSyntheseStats(data.inscription);
        @if(stats) {
        <div class="form-field-critere" style="width: 100%;">
          <label class="critere-label fx-direction-row fx-start-center">
            <mat-icon style="font-size:16px;height:16px;width:16px;margin-right:4px">summarize</mat-icon>
            Synthèse de l'évaluation
          </label>
          <ng-container *ngTemplateOutlet="syntheseTable; context: { stats: stats }"></ng-container>
        </div>
        }
        }
      </div>
    </form>
  </mat-dialog-content>
</ng-template>

<ng-template #inscriptionInfoEvaluation let-data>

  @let evalInscription = data.evalInscrData();

  <app-dialog-header [title]="'Évaluations ' + data.nomReferent" />
  <mat-dialog-content class="content-dialog">
    @if(!evalInscription.loading){
    <mat-accordion style="display: block;">
      @for (item of evalInscription.result; track $index) {

      @let evaluation = item.evaluation;
      @let evalInscription = item.evaluationInscription;

      @if(evaluation.idEvaluation !== data.idEvaluation){
      <mat-expansion-panel>
        <mat-expansion-panel-header class="panel-header-dialog" style="height: auto; padding-block: 10px;">
          <mat-panel-title>
            <div class="panel-chip panel-chip-primary" [class.panel-chip-examen]="evaluation.examen">
              @if(evaluation.examen){
              <app-icon type="do" icon="groupe-commission" matTooltip="Examen" class="accent" />
              }@else {
              <app-icon type="do" icon="evaluation" matTooltip="Évaluation" class="primary" />
              }
              <span>N°{{ evaluation.numEvaluation }}</span>
            </div>
            @if(evaluation.examen){
            <mat-icon [style.color]="evalInscription.reussiteExamen ? '#6EBF6D' : '#DA5255'"
              [matTooltip]="evalInscription.reussiteExamen ? 'Réussite à l\'examen' : 'Échec à l\'examen'"
              style="min-width: 24px; margin-left: 6px;">{{evalInscription.reussiteExamen ? 'check_circle' :
              'cancel'}}</mat-icon>
            }
            <span style="margin-inline: 6px;">{{evaluation.libelle.libelle}}</span>
          </mat-panel-title>
          <mat-panel-description>
            <div class="fx-direction-row fx-wrap fx-gap-5" style="flex: 1; align-items: center;">
              <div class="panel-chip">
                <app-icon type="do" icon="date-range" />
                @if (evaluation.dateDebut === evaluation.dateFin) {
                {{evaluation.dateDebut | date:'shortDate'}}
                }@else{
                Du {{evaluation.dateDebut | date:'shortDate'}} au {{evaluation.dateFin | date:'shortDate'}}
                }
              </div>
              @if (evaluation.cours) {
              <div class="panel-chip">
                <app-icon type="do" icon="cours" matTooltip="Cours" />
                {{evaluation.cours.libelle}}
              </div>
              }
              @if (evaluation.discipline) {
              <div class="panel-chip">
                <app-icon type="do" icon="discipline" matTooltip="Discipline" />
                {{evaluation.discipline.libelle}}
              </div>
              }
            </div>
            @if(evalInscription.noteGlobale){
            <span class="note" matTooltip="Note globale">{{evalInscription.noteGlobale}}</span>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="container-global-info" style="margin-bottom: 5px;">
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label">Appréciation</label>
            <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
              <span class="texte-compact">{{ evalInscription.appreciation }}</span>
            </mat-card-content>
          </mat-card>
        </div>

        @if (evaluation.criteresNotation && evalInscription.criteresData){
        <div class="container-global-info">
          <mat-card appearance="outlined" class="evaluation-card">
            <mat-card-content class="evaluation-content" style="padding: 0;">
              @if (config?.sortedByCode) {
              @for (group of groupCriteresByCode(evaluation.criteresNotation); track group.code) {
              <div class="critere-group">
                @if (group.code) {
                <div class="critere-group-header">{{group.code}}</div>
                }
                <div class="criteres-compact-list">
                  @for (critere of group.criteres; track $index) {
                  <ng-container
                    *ngTemplateOutlet="critereInfoCompact; context: { critere: critere, evalInscription: evalInscription }"></ng-container>
                  }
                </div>
              </div>
              }
              } @else {
              <div class="criteres-compact-list">
                @for (critere of evaluation.criteresNotation; track $index) {
                <ng-container
                  *ngTemplateOutlet="critereInfoCompact; context: { critere: critere, evalInscription: evalInscription }"></ng-container>
                }
              </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
        @let synthese = getSyntheseStatsForEval(evaluation.criteresNotation, evalInscription);
        @if (synthese) {
        <div class="container-global-info" style="margin-top: 5px;">
          <mat-card appearance="outlined" class="evaluation-card">
            <label class="evaluation-label fx-direction-row fx-start-center">
              <mat-icon style="font-size:16px;height:16px;width:16px;margin-right:4px">summarize</mat-icon>
              Synthèse de l'évaluation
            </label>
            <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
              <ng-container *ngTemplateOutlet="syntheseTable; context: { stats: synthese }"></ng-container>
            </mat-card-content>
          </mat-card>
        </div>
        }
        }
      </mat-expansion-panel>
      }
      }@empty {
      <div style="padding: 50px; text-align: center;">
        Aucune évaluation
      </div>
      }
    </mat-accordion>
    }@else {<app-loader style="padding: 50px;" message="Chargement des données..." />}
  </mat-dialog-content>
</ng-template>

<ng-template #syntheseTable let-stats="stats">
  <table class="synthese-table">
    <thead>
      <tr>
        <th></th>
        <th><mat-icon
            style="font-size:16px;height:16px;width:16px;color:#6EBF6D;vertical-align:middle">check_circle</mat-icon>
        </th>
        <th><mat-icon
            style="font-size:16px;height:16px;width:16px;color:#DA5255;vertical-align:middle">cancel</mat-icon></th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      @if(stats.obligatoires.total > 0) {
      <tr>
        <td class="synthese-label">
          <mat-icon color="warn"
            style="font-size:14px;height:14px;width:14px;vertical-align:middle;margin-right:4px;flex-shrink: 0;">error</mat-icon>Obligatoires
        </td>
        <td class="synthese-reussi">{{stats.obligatoires.reussi}}</td>
        <td class="synthese-echec">{{stats.obligatoires.echec}}</td>
        <td class="synthese-total">{{stats.obligatoires.total}}</td>
      </tr>
      }
      @if(stats.nonObligatoires.total > 0) {
      <tr>
        <td class="synthese-label">Non obligatoires</td>
        <td class="synthese-reussi">{{stats.nonObligatoires.reussi}}</td>
        <td class="synthese-echec">{{stats.nonObligatoires.echec}}</td>
        <td class="synthese-total">{{stats.nonObligatoires.total}}</td>
      </tr>
      }
      <tr class="synthese-row-total">
        <td class="synthese-label">Tous</td>
        <td class="synthese-reussi">{{stats.tous.reussi}}</td>
        <td class="synthese-echec">{{stats.tous.echec}}</td>
        <td class="synthese-total">{{stats.tous.total}}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
